var exports = {
  "S": "issueTypeColorIndicator__E5j3OD",
};

module.exports = exports;
